import { render, staticRenderFns } from "./collection-modify.vue?vue&type=template&id=274ac238&scoped=true&"
import script from "./collection-modify.vue?vue&type=script&lang=js&"
export * from "./collection-modify.vue?vue&type=script&lang=js&"
import style0 from "./collection-modify.vue?vue&type=style&index=0&id=274ac238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ac238",
  null
  
)

export default component.exports